import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import QuizQuestion from './QuizQuestion';

class Quiz extends Component {

    constructor() {
        super();

        this.state = {
            currentQuestion: 0,
            displayResponse: false,
            resetClock: () => {}
        };
    }

    incrementQuestion() {
        this.setState({
            currentQuestion: this.state.currentQuestion + 1,
            displayResponse: false
        });
    }

    displayResponse() {
        this.setState({
            displayResponse: true
        });
    }

    setResetClockFunction(resetClockFunction) {

        this.setState({
            resetClock: resetClockFunction
        });
    }

    render() {

        if (this.state.currentQuestion === this.props.questions.length) {
            this.props.history.push("/fact");
            return null;
        }

        return (
            <body>
            <section className="quiz-page-container">
                <header className="page-info">
                    <h1>Audition</h1>
                </header>
                <QuizQuestion
                    questionCount={this.props.questions.length}
                    question={this.props.questions[this.state.currentQuestion]}
                    questionIndex={this.state.currentQuestion}
                    displayResponse={() => this.displayResponse()}
                    responseIsDisplayed={this.state.displayResponse}
                    currentQuestion={this.state.currentQuestion}
                    currentTime={this.state.currentTime}
                    setResetClockFunction={(resetClockFunction) => this.setResetClockFunction(resetClockFunction)}
                    isReplay={this.state.isReplay}
                />
                {
                    this.state.displayResponse &&
                    <p>{this.props.questions[this.state.currentQuestion].funFact}</p>
                }
                <footer className="page-footer">

                    <Link className="button-primary button-exit" to="/songs">Exit</Link>
                    <button className={"button-primary "+(!this.state.displayResponse ? "button-primary-inactive" : "")}
                            onClick={() => {
                                if(this.state.displayResponse) {
                                    this.incrementQuestion();
                                    this.state.resetClock();
                                }
                            }}
                    >Next</button>

                </footer>

            </section>
            </body>
        );
    }
}

export default withRouter(Quiz);


// WEBPACK FOOTER //
// ./src/components/Quiz.js